import EditIcon from '@mui/icons-material/Edit'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { Box, Grid, IconButton, Typography } from '@mui/material'
import { Table } from 'antd'
import dayjs from 'dayjs'
import { useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { openModal } from '../../../../store/reducers/modal/modal.slice'
import CircularLoading from '../../../components/CircularProgress'
import ImgTag from '../../../components/ImgTag'
import Pagination from '../../../components/Pagination'
import Username from '../../../components/Username'
import { ONLY_DATE_FORMAT, ONLY_TIME_FORMAT } from '../../../constants/global'
import { IUserLists } from '../../../types/user'
import { IFilterMapped } from './UserFilter'
import { UserFormModal } from './UserFormModal'
import { UserFormResetPasswordModal } from './UserFormResetPaswordModal'
import UserRoleTag from './UserRoleTag'
import UserStatusTag from './UserStatusTag'
import { AbilityContext } from '../../../components/Ability'

interface IUsersTableProps {
  isLoading: boolean
  data: IUserLists[]
  onUpdateUserSuccess: () => void
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void
  handlePageChange: (filter: IFilterMapped) => void
  total: number
}

const UsersTable = ({
  isLoading,
  data,
  onUpdateUserSuccess,
  filter,
  onFilterChange,
  handlePageChange,
  total,
}: IUsersTableProps) => {
  const dispatch = useDispatch()
  const ability = useContext(AbilityContext)
  const [userSelect, setUserSelect] = useState<IUserLists>()
  const [isModalResetPassword, setIsModalResetPassword] =
    useState<boolean>(false)

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'numberRow',
      key: 'numberRow',
      width: 80,
      align: 'center' as const,
      render: (numberRow: number) => {
        return (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            textAlign={'center'}
          >
            {numberRow}
          </Typography>
        )
      },
    },
    {
      title: 'ชื่อผู้ใช้งาน',
      dataIndex: 'username',
      key: 'username',
      align: 'center' as const,
      render: (username: string, userData: IUserLists) => {
        return (
          <Grid container spacing={2} alignItems={'center'} minWidth={200}>
            <Grid item>
              <ImgTag imageUrl={userData.image} name={username} />
            </Grid>
            <Grid item>
              <Username username={username} roles={userData.roles} />
            </Grid>
          </Grid>
        )
      },
    },
    {
      title: 'ชื่อ-สกุล',
      dataIndex: 'name',
      key: 'name',
      align: 'center' as const,
      render: (name: any) => {
        return (
          <Typography variant="subtitle2" color="text.secondary" minWidth={200}>
            {name}
          </Typography>
        )
      },
    },
    {
      title: 'เบอร์ติดต่อ',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      align: 'center' as const,
      render: (phoneNumber: any) => {
        return (
          <Typography variant="subtitle2" color="text.secondary" minWidth={80}>
            {phoneNumber}
          </Typography>
        )
      },
    },
    {
      title: 'สถานะผู้ใช้งาน',
      dataIndex: 'isAvailable',
      key: 'isAvailable',
      align: 'center' as const,
      render: (isAvailable: boolean) => {
        return (
          <Box sx={{ minWidth: 100 }}>
            <UserStatusTag isAvailable={isAvailable} />
          </Box>
        )
      },
    },
    {
      title: 'สิทธิ์การใช้งาน',
      dataIndex: 'roles',
      key: 'roles',
      align: 'center' as const,
      render: (roles: any) => {
        return (
          <Box sx={{ minWidth: 100 }}>
            <UserRoleTag roles={roles} />
          </Box>
        )
      },
    },
    {
      title: 'Merchant',
      dataIndex: 'merchantPrefix',
      key: 'merchantPrefix',
      align: 'center' as const,
      render: (merchantPrefix: string) => {
        return (
          <Typography variant="subtitle2" color="text.secondary">
            {merchantPrefix}
          </Typography>
        )
      },
    },
    {
      title: 'วันที่เพิ่ม',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 120,
      align: 'center' as const,
      render: (createdAt: string) => {
        return (
          <Grid container flexDirection={'column'}>
            <Grid item>
              <Typography variant="subtitle2" color="text.secondary">
                {dayjs(createdAt).format(ONLY_DATE_FORMAT)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" color="text.secondary">
                {dayjs(createdAt).format(ONLY_TIME_FORMAT)}
              </Typography>
            </Grid>
          </Grid>
        )
      },
    },
    {
      title: 'วันที่แก้ไข',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      align: 'center' as const,
      render: (updatedAt: string) => {
        return (
          <Grid container flexDirection={'column'} justifyContent={'center'}>
            <Grid item>
              <Typography variant="subtitle2" color="text.secondary">
                {dayjs(updatedAt).format(ONLY_DATE_FORMAT)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" color="text.secondary">
                {dayjs(updatedAt).format(ONLY_TIME_FORMAT)}
              </Typography>
            </Grid>
          </Grid>
        )
      },
    },
    {
      dataIndex: '',
      key: 'action',
      align: 'center' as const,
      width: 170,
      render: (_: undefined, userData: IUserLists) => {
        return (
          <Grid container justifyContent={'center'} spacing={2} width={120}>
            {/* {ability.can('manage', 'User', 'update') && ( */}
            <Grid item>
              <IconButton
                onClick={() =>
                  dispatch(
                    openModal({
                      title: 'แก้ไขข้อมูลพนักงาน',
                      content: (
                        <UserFormModal
                          user={userData}
                          onUpdateUserSuccess={onUpdateUserSuccess}
                        />
                      ),
                    }),
                  )
                }
              >
                <EditIcon />
              </IconButton>
            </Grid>
            {/* )} */}
            {/* {ability.can('manage', 'User', 'changePassword') && ( */}
            <Grid item>
              <IconButton
                onClick={() => {
                  setUserSelect(userData)
                  setIsModalResetPassword(true)
                }}
              >
                <VpnKeyIcon />
              </IconButton>
            </Grid>
            {/* )} */}
            {/* {user.username !== userData.username &&
            <Grid item>
              <IconButton
                onClick={() => onHandleDeleteUser(userData.objectId!)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          } */}
          </Grid>
        )
      },
    },
  ]

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      {/*<UserFormModal*/}
      {/*  onUpdateUserSuccess={onUpdateUserSuccess}*/}
      {/*  userData={userSelect}*/}
      {/*/>*/}
      <UserFormResetPasswordModal
        isOpen={isModalResetPassword}
        onUpdateUserSuccess={onUpdateUserSuccess}
        onClose={(visible) => {
          setIsModalResetPassword(visible)
        }}
        username={userSelect?.username!}
      />
      <Pagination
        total={total}
        current={filter.page!}
        pageSize={filter.perPage!}
        onChange={(page, perPage) =>
          handlePageChange({ ...filter, page, perPage })
        }
        mb={2}
      />
      <Table
        size={'middle'}
        columns={columns}
        scroll={{
          x: columns.reduce(
            (pre, cur: any) => (cur.width ? cur.width + pre : pre),
            0,
          ),
        }}
        dataSource={data?.map((userData: IUserLists, index: number) => {
          return {
            ...userData,
            key: userData.objectId,
            numberRow:
              index + 1 + ((filter.page || 0) - 1) * (filter.perPage || 0),
          }
        })}
        bordered
        pagination={false}
      />
      <Pagination
        total={total}
        current={filter.page!}
        pageSize={filter.perPage!}
        onChange={(page, perPage) =>
          handlePageChange({ ...filter, page, perPage })
        }
      />
    </>
  )
}

export default UsersTable
